"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProcessor = void 0;
var node_fetch_1 = __importDefault(require("node-fetch"));
var pino_1 = __importDefault(require("pino"));
var ANALYTICS_ENDPOINT = 'analytics/flags/';
// Used to control how often we send data(in seconds)
var ANALYTICS_TIMER = 10;
var AnalyticsProcessor = /** @class */ (function () {
    /**
     * AnalyticsProcessor is used to track how often individual Flags are evaluated within
     * the Flagsmith SDK. Docs: https://docs.flagsmith.com/advanced-use/flag-analytics.
     *
     * @param data.environmentKey environment key obtained from the Flagsmith UI
     * @param data.baseApiUrl base api url to override when using self hosted version
     * @param data.requestTimeoutMs used to tell requests to stop waiting for a response after a
            given number of milliseconds
     */
    function AnalyticsProcessor(data) {
        this.requestTimeoutMs = 3000;
        this.analyticsEndpoint = data.baseApiUrl + ANALYTICS_ENDPOINT;
        this.environmentKey = data.environmentKey;
        this.lastFlushed = Date.now();
        this.analyticsData = {};
        this.requestTimeoutMs = data.requestTimeoutMs || this.requestTimeoutMs;
        this.logger = data.logger || (0, pino_1.default)();
    }
    /**
     * Sends all the collected data to the api asynchronously and resets the timer
     */
    AnalyticsProcessor.prototype.flush = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.currentFlush || !Object.keys(this.analyticsData).length) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.currentFlush = (0, node_fetch_1.default)(this.analyticsEndpoint, {
                            method: 'POST',
                            body: JSON.stringify(this.analyticsData),
                            timeout: this.requestTimeoutMs,
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Environment-Key': this.environmentKey
                            }
                        });
                        return [4 /*yield*/, this.currentFlush];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        // We don't want failing to write analytics to cause any exceptions in the main
                        // thread so we just swallow them here.
                        this.logger.warn('Failed to post analytics to Flagsmith API. Not clearing data, will retry.');
                        return [2 /*return*/];
                    case 4:
                        this.currentFlush = undefined;
                        return [7 /*endfinally*/];
                    case 5:
                        this.analyticsData = {};
                        this.lastFlushed = Date.now();
                        return [2 /*return*/];
                }
            });
        });
    };
    AnalyticsProcessor.prototype.trackFeature = function (featureName) {
        this.analyticsData[featureName] = (this.analyticsData[featureName] || 0) + 1;
        if (Date.now() - this.lastFlushed > ANALYTICS_TIMER * 1000) {
            this.flush();
        }
    };
    return AnalyticsProcessor;
}());
exports.AnalyticsProcessor = AnalyticsProcessor;
